import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';

@Directive({
    selector: '[appTooltip]'
})
export class TooltipDirective implements OnDestroy {
  @Input('appTooltip') tooltipTitle?: string;
  tooltip: HTMLElement | null = null;
  offset = 10;

  constructor(private el: ElementRef) {}

  @HostListener('mouseenter') onMouseEnter() {
    if (this.tooltipTitle && !this.tooltip) { this.show(); }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltip) { this.hide(); }
  }

  @HostListener('window:beforeunload') onWindowBeforeUnload() {
    if (this.tooltip) { this.hideImmediate(); }
  }

  ngOnDestroy() {
    this.hideImmediate();
  }

  show() {
    this.tooltip = document.createElement('span');
    this.tooltip.style.position = 'absolute';
    this.tooltip.style.zIndex = '1000';
    this.tooltip.style.backgroundColor = '#609244';
    this.tooltip.style.color = '#fff';
    this.tooltip.style.padding = '5px';
    this.tooltip.style.borderRadius = '4px';
    this.tooltip.style.fontSize = '14px';
    this.tooltip.style.fontWeight = 'bold';
    this.tooltip.style.whiteSpace = 'nowrap';
    this.tooltip.innerHTML = this.tooltipTitle || '';
    this.tooltip.style.transition = 'opacity 0.3s ease-in-out';
    this.tooltip.style.opacity = '0';
    document.body.appendChild(this.tooltip);

    const rect = this.el.nativeElement.getBoundingClientRect();
    const tooltipRect = this.tooltip.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    
    let top = rect.bottom + scrollTop + this.offset;
    let left = rect.left + scrollLeft + (rect.width - tooltipRect.width) / 2;

    // Asegurarse de que el tooltip no se salga del viewport
    if (top + tooltipRect.height > window.innerHeight + scrollTop) {
      top = rect.top + scrollTop - tooltipRect.height - this.offset;
    }
    if (left + tooltipRect.width > window.innerWidth + scrollLeft) {
      left = window.innerWidth + scrollLeft - tooltipRect.width - this.offset;
    }
    if (left < scrollLeft) {
      left = scrollLeft + this.offset;
    }

    this.tooltip.style.top = `${top}px`;
    this.tooltip.style.left = `${left}px`;

    // Forzar reflujo para que la transición se aplique correctamente
    window.getComputedStyle(this.tooltip).opacity;
    this.tooltip.style.opacity = '1';
  }

  hide() {
    if (this.tooltip) {
      this.tooltip.style.opacity = '0';
      setTimeout(() => {
        if (this.tooltip) {
          document.body.removeChild(this.tooltip);
          this.tooltip = null;
        }
      }, 300); // Duración de la transición
    }
  }

  hideImmediate() {
    if (this.tooltip) {
      document.body.removeChild(this.tooltip);
      this.tooltip = null;
    }
  }
}
